<template>
<div class="div_sec">

  <el-row :gutter="60">
    <el-col :span="24" class="card-01">
      <el-row>
        <el-col :span="21" class="modal_title middle_blue">Kontrola
        </el-col>
        <el-col :span="21"> <span class="modal_title green small">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
        </el-col>
        <el-col :span="3">
          <el-button :disabled="modal_checkup_ro" class="btn-green" icon="el-icon-plus" size="small" @click="checkup_new"> Nová kontrola</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table
            ref="checkups_table"
            :data="checkups"
            style="width: 100%; word-break: normal;"
            row-key="id_checkup"
            v-loading="loading_checkups"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(211, 227, 218, 0.8)"
            :default-sort="{prop:'id_checkup', order:'ascending'}"
            border
            highlight-current-row
            @sort-change="SortChange_checkups"
            :stripe="true"
          >
            <el-table-column
              prop="id_checkup"
              label="ID kontroly"
              min-width="100"
              sortable>
            </el-table-column>
            <el-table-column
              prop="user_name"
              label="Lékař"
              min-width="100"
              sortable="custom">
            </el-table-column>
            <el-table-column
              prop="dept_name"
              label="Oddělení"
              min-width="100"
              sortable="custom">
            </el-table-column>
            <el-table-column
              prop="id_medication"
              label="ID léčby"
              min-width="100"
              sortable>
            </el-table-column>
            <el-table-column
              prop="id_examination"
              label="ID diag./udál."
              min-width="100"
              sortable>
            </el-table-column>
            <el-table-column
              prop="id_operation"
              label="ID operace"
              min-width="100"
              sortable>
            </el-table-column>
            <el-table-column
              prop="dt_when"
              label="Datum"
              sortable>
            </el-table-column>
            <el-table-column
              width="320"
              fixed="right"
              label="Akce"
              align="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button :disabled="modal_checkup_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="examination_new( props.$index, props.row, $event )">Diag./ud.</el-button>
                  <el-button :disabled="modal_checkup_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="medication_new( props.$index, props.row, $event )">Léčba</el-button>
                  <el-button class="btn-grey-lit" size="mini" icon="el-icon-view" @click="checkup_show( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="modal_checkup_ro" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="checkup_edit( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="modal_checkup_ro" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="checkup_delete( props.$index, props.row, $event )"></el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-col>
  </el-row>

</div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  let notifier = new Vue();

  export default {
    computed: {
      ...mapState({

        checkups: state => state.checkups,
        checkup: state => state.checkup,
        sorting_checkups: state => state.sorting_checkups,
        loading_checkups: state => state.loading_checkups,

        patient: state => state.patient,
        examination: state => state.examination,
        medication: state => state.medication,

        modal_checkup_ro: state => state.modal_checkup_ro,

      }),

      ...mapGetters({

      }),

    },


    data () {
      return {

      }
    },

    methods: {
      ...mapMutations({
        m_modal_checkup: 'm_modal_checkup',
        m_modal_checkup_ro: 'm_modal_checkup_ro',
        m_checkup_by_key: 'm_checkup_by_key',
        m_checkup_reset: 'm_checkup_reset',

        m_examination_reset: 'm_examination_reset',
        m_modal_examination: 'm_modal_examination',
        m_modal_examination_ro: 'm_modal_examination_ro',

        m_medication_reset: 'm_medication_reset',
        m_modal_medication: 'm_modal_medication',
        m_modal_medication_ro: 'm_modal_medication_ro',

      }),


      ...mapActions({
        loginuser: state => state.loginuser,

        a_checkup: 'a_checkup',
        a_checkups: 'a_checkups',
        a_checkup_delete: 'a_checkup_delete',

        a_med_cis_bio_ter_lek: 'a_med_cis_bio_ter_lek',
        a_med_cis_protokol: 'a_med_cis_protokol',
        a_med_cis_chem_int_cyt: 'a_med_cis_chem_int_cyt',
        a_med_cis_chem_int_inthe_inver_cyt: 'a_med_cis_chem_int_inthe_inver_cyt',
        a_med_cis_udr_chem_inthe_inver_cyt: 'a_med_cis_udr_chem_inthe_inver_cyt',

        a_exam_cis_sk_nadoru_get: 'a_exam_cis_sk_nadoru_get',

        }),


      checkup_new() {
        this.m_checkup_reset();
        this.checkup.id_patient = this.patient.id_patient;
        this.m_modal_checkup(true);
      },


      __checkup_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_checkup_delete( {'id_checkup': row.id_checkup} );
      },


      checkup_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.$confirm(`Opravdu chcete položku smazat?`, 'Upozornění', {
          confirmButtonText: 'ANO',
          cancelButtonText: 'NE',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.a_checkup_delete( {'id_checkup': row.id_checkup} );
          this.a_checkups( {} );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Smazání položky přerušeno.'
          });
        });
      },


      checkup_show (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_checkup_ro(true);
        this.m_checkup_reset();
        this.checkup.id_checkup = row.id_checkup;
        this.a_checkup( {'id_checkup': row.id_checkup} );
        this.m_modal_checkup(true);
      },


      checkup_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_checkup_ro(false);
        this.m_checkup_reset();
        this.checkup.id_checkup = row.id_checkup;
        this.a_checkup( {'id_checkup': row.id_checkup} );
        this.m_modal_checkup(true);
      },


      examination_new(index, row, event) {
        this.m_modal_examination_ro(false);
        this.m_examination_reset();
        this.examination.id_patient = this.patient.id_patient;
        this.examination.id_checkup = row.id_checkup;
        this.a_exam_cis_sk_nadoru_get();
        this.m_modal_examination(true);
      },


      medication_new(index, row, event) {
        this.m_modal_medication_ro(false);
        this.m_medication_reset();
        this.a_med_cis_bio_ter_lek();
        this.a_med_cis_protokol();
        this.a_med_cis_chem_int_cyt();
        this.a_med_cis_chem_int_inthe_inver_cyt();
        this.a_med_cis_udr_chem_inthe_inver_cyt();
        this.medication.id_patient = this.patient.id_patient;
        this.medication.id_checkup = row.id_checkup;
        this.m_modal_medication(true);
      },


      SortChange_checkups(val) {
        this.sorting_checkups.sorting_prop = val.prop;
        this.sorting_checkups.sorting_ordering = val.order;
        this.a_checkups();
      },


      handleChange(value) {
        console.log(value);
      },


      vymaz_data(value) {
        this.checkup[value] = null;
        console.log(value);
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },



      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


    },

    beforeMount () {
    },

    created () {
    },

    mounted () {

    },

    beforeDestroy () {
    },


  }
</script>

<style lang="scss">

.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}

.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

.el-select .el-input {
  width: 220px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
   margin-bottom: 0 !important;
  }

.el-select {
  padding: 0 20px 10px 0 !important;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #7b8d9f;
    cursor: not-allowed;
}

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}



</style>

